import {sendRequest} from "./utils";
import {debounce} from "lodash";

export function addProductCardListeners() {
  document.querySelectorAll(".product-card").forEach((el) => {
    let input = el.querySelector("input[name='productCount']");
    if (input) {
      let data = input.dataset;

      let output = el.querySelector('output[name="result"]');
      let originOutput = el.querySelector('output[name="originResult"]');

      input.addEventListener("input", () => {
        if (input.value < 0) {
          input.value = 0;
        }

        output.value = (
          parseFloat(input.dataset.discount_price) *
          parseFloat(input.value || 0)
        ).toFixed(2);

        if (originOutput) {
          originOutput.value = (
            parseFloat(input.dataset.price) * parseFloat(input.value || 0)
          ).toFixed(2);
        }
      });

      input.dispatchEvent(new Event("input"));

      el.querySelector("button[name='productAddToCartBtn']").addEventListener(
        "click",
        () => {
          sendRequest(data.url, {
            productSlug: data.slug,
            count: input.value,
            productPriceId: data.container_id,
          });
        }
      );
    }
  });
}

export function addProductShowListeners() {
  let showForm = document.querySelector("form#productShow");

  if (showForm) {
    let countInput = showForm.querySelector('input[name="count"]');
    let containerSelect = showForm.querySelector('select[name="containerId"]');
    let output = showForm.querySelector('output[name="result"]');
    let originOutput = showForm.querySelector('output[name="discountResult"]');

    showForm.addEventListener("submit", (e) => {
      e.preventDefault();
      sendRequest(showForm.action, {
        productSlug: countInput.dataset.slug,
        count: countInput.value,
        productPriceId: containerSelect
          ? containerSelect.value
          : countInput.dataset.container_id,
      });
    });

    if (containerSelect) {
      containerSelect.addEventListener("input", () => {
        updateResult();
      });
    }

    countInput.addEventListener("input", () => {
      if (countInput.value < 0) {
        countInput.value = 0.0;
      }
      updateResult();
    });

    function updateResult() {
      let selectedContainerOption =
        containerSelect?.options[containerSelect.selectedIndex];

      let priceByContainer = selectedContainerOption?.dataset.price;
      let priceByOne = countInput.dataset.price;

      let originPriceByContainer =
        selectedContainerOption?.dataset.origin_price;
      let originPriceByOne = countInput.dataset.origin_price;

      output.value = (
        parseFloat(priceByContainer ?? priceByOne) *
        parseFloat(countInput.value || 0)
      ).toFixed(2);

      if (originOutput) {
        originOutput.value = (
          parseFloat(originPriceByContainer ?? originPriceByOne) *
          parseFloat(countInput.value || 0)
        ).toFixed(2);
      }
    }

    countInput.dispatchEvent(new Event("input"));
  }
}

export function removeItem() {
  for (const el of document.querySelectorAll(".cart-item")) {
    let removeBtn = el.querySelector("button.js-cart-remove");
    removeBtn.addEventListener("click", () => {
      let requestData = {
        cartKey: removeBtn.dataset.key,
      };
      sendRequest(removeBtn.dataset.url, requestData, "DELETE").then(() => {});
      el.remove();
      document.querySelector("input.count")?.dispatchEvent(new Event("input"));
    });
  }
}

export function cartItemListeners() {
  function calcTotalPrice() {
    let totalInput = document.querySelector('output[name="cartTotal"]');
    let total = 0;
    document.querySelectorAll("output.product-price").forEach((el) => {
      total += parseFloat(el.value >= 0 ? el.value : 0);
    });

    totalInput.value = total.toFixed(2);
  }

  document.querySelectorAll(".cart-item").forEach((el) => {
    let output = el.querySelector("output.product-price");
    let count = el.querySelector("input.count");

    let originOutput = el.querySelector("output.product-origin");

    count.addEventListener("input", () => {
      if (count.value < 0) {
        count.value = 0;
      }

      output.value = (
        parseFloat(count.value || 0) * parseFloat(count.dataset.price || 0)
      ).toFixed(2);

      if (originOutput) {
        originOutput.value = (
          parseFloat(count.value || 0) *
          parseFloat(count.dataset.origin_price || 0)
        ).toFixed(2);
      }
    });

    count.addEventListener("input", () => {
      calcTotalPrice();
    });

    count.dispatchEvent(new Event("input"));

    count.addEventListener(
      "change",
      debounce(() => {
        let parsedCount = parseFloat(count.value);
        if (parsedCount && parsedCount > 0) {
          sendRequest(
            count.dataset.url,
            {
              key: parseInt(count.dataset.key),
              productSlug: count.dataset.slug,
              count: parsedCount,
              productPriceId: parseInt(count.dataset.container_id),
            },
            "PATCH"
          );
        }
      }, 1000)
    );
  });
}

export function cartCountListener() {
  let cartOutput = document.querySelector('output[name="cartCount"]');
  cartOutput?.addEventListener("input", () => {
    let parentSpanClasses = cartOutput.closest("span").classList;
    if (cartOutput.value > 0) {
      parentSpanClasses.remove("invisible-cart-count");
    } else {
      parentSpanClasses.add("invisible-cart-count");
    }
  });

  cartOutput?.dispatchEvent(new Event("input"));
}
